import Toast from "../components/toast.vue";
const obj = {};
obj.install = function(Vue) {

  //1. 创建组件构造器
  const toastContrustor = Vue.extend(Toast);
  
  Vue.prototype.$toast = function(message, type, delayer = 3000) {

    //2. new的方式，根据组件构造器，可以创建出来一个组件对象
    const toast = new toastContrustor();

    Object.assign(toast, { message, type, delayer });

    //3. 将组件对象手动的挂载到一个元素上面

    toast.$mount(document.createElement("div"));

    //4. toast.$el对应的就是div
    document.body.appendChild(toast.$el);
  };
};

export default obj;




// WEBPACK FOOTER //
// ./src/utils/toast.js